import { render } from "./GptMain.vue?vue&type=template&id=8087a9ec"
import script from "./GptMain.vue?vue&type=script&lang=js"
export * from "./GptMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__